import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText';

@withTranslation(['Offers', 'main'], { i18n, wait: !!window })
export default class GeoDialog extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    children: PropTypes.string
  }

  handleClose = () => {
    this.props.onClose();
  };

  render() {
    const { t, open, children } = this.props;
    const actions = [
      <Button
        color="primary"
        onClick={this.handleClose}
      >{t('main:ok')}</Button>
    ];

    return (
      <Dialog
        actions={actions}
        open={open}
        onClose={this.handleClose}
      >
        <DialogTitle>{t('filters.region_id')}</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ lineHeight: 1.3 }}>
            {children}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    );
  }
}
